export const COPY_RESET_PASSWORD_TITLE = "Reset password";
export const COPY_INVALID_RESET_URL =
  "Sorry, there is an error with your reset password link. It could have expired or have been used already.";
export const COPY_RESET_PASSWORD_SUCCESS_TITLE = "Password reset!";
